import { gql } from '@apollo/client';

export const setDefaultHeader = (orgId: string | number) => ({
  'X-Organisation-Id': String(orgId),
});

// Get All Organisations
export const GET_ORGANISATIONS = gql`
  query {
    optInOrganisations {
      orgId
      name
      description
    }
  }
`;

// Get Organisation
export const GET_ORGANISATION = gql`
  query GetOrganisation($orgId: Int!) {
    organisation(orgId: $orgId) {
      organisationEntityId
      name
      description
      prefixSettings {
        value
        requiredByDefault
      }
    }
  }
`;

// Get Animals
export const GET_ANIMALS = gql`
  query GetAnimals(
    $currentPage: Int!
    $pageSize: Int!
    $orgId: Int!
    $filterInput: QueryEntityFilterInput!
    $sortInput: SortInput
  ) {
    animals(
      currentPage: $currentPage
      pageSize: $pageSize
      orgId: $orgId
      filterInput: $filterInput
      sortInput: $sortInput
    ) {
      currentPage
      pageSize
      rowCount
      results {
        entityId
        entityGuid
        breeder {
          entityGuid
          entityDetailValues {
            entityDetailName
            value
          }
        }
        entityDetailValues {
          entityDetailName
          value
        }
        entityDetailValues {
          entityId
          entityDetailName
          value
          additionalInfo {
            id
            name
          }
        }
      }
    }
  }
`;

// Get Animals
export const GET_ANIMAL_DETAILS = gql`
  query GetAnimalDetails($orgId: Int!) {
    animalDetails(orgId: $orgId) {
      entityDetailId
      entityDetailName
      isDatabaseSearchEnable
      entityDetailConfigs {
        labelText
        detailName
        detailTypeValue
        options {
          label
          value
        }
      }
    }
  }
`;

// Get Form
export const GET_FORM = gql`
  query GetForm($type: Int!) {
    form(type: $type) {
      value
    }
  }
`;

// Get Members
export const GET_MEMBERS = gql`
  query GetMembers(
    $currentPage: Int!
    $pageSize: Int!
    $orgId: Int!
    $filterInput: QueryEntityFilterInput
    $sortInput: SortInput
  ) {
    members(
      currentPage: $currentPage
      pageSize: $pageSize
      orgId: $orgId
      filterInput: $filterInput
      sortInput: $sortInput
    ) {
      currentPage
      pageSize
      rowCount
      results {
        entityId
        entityGuid
        entityDetailValues {
          entityId
          entityDetailName
          value
          additionalInfo {
            id
            name
          }
        }
      }
    }
  }
`;

// Get Role
export const GET_ROLES = gql`
  query GetRoles($userId: Int, $orgId: Int) {
    roles(userId: $userId, orgId: $orgId) {
      userId
      organisationId
      roleDetail {
        roleName
        roleDescription
      }
      organisation {
        name
      }
    }
  }
`;

// Get Animal
export const GET_ANIMAL = gql`
  query GetAnimal($entityId: Int!) {
    animal(entityId: $entityId) {
      entityDetailEnhancers {
        name
        value
      }
      entityGuid
      entityId
      breeder {
        entityGuid
        entityDetailValues {
          entityDetailName
          value
        }
      }
      entityDetailValues {
        entityId
        entityDetailName
        value
        additionalInfo {
          id
          ident
          name
        }
      }
      pedigree {
        animalName
        entityDetailEnhancers {
          name
          value
        }
        ownerName
        ownerId
        tags {
          entityId
          entityDetailName
          value
          additionalInfo {
            id
            name
          }
        }
        sire {
          animalName
          entityDetailEnhancers {
            name
            value
          }
          ownerName
          ownerId
          tags {
            entityId
            entityDetailName
            value
            additionalInfo {
              id
              name
            }
          }
          sire {
            animalName
            entityDetailEnhancers {
              name
              value
            }
            ownerName
            ownerId
            tags {
              entityId
              entityDetailName
              value
              additionalInfo {
                id
                name
              }
            }
            sire {
              animalName
              entityDetailEnhancers {
                name
                value
              }
              ownerName
              ownerId
              tags {
                entityId
                entityDetailName
                value
                additionalInfo {
                  id
                  name
                }
              }
            }
            dam {
              animalName
              entityDetailEnhancers {
                name
                value
              }
              ownerName
              ownerId
              tags {
                entityId
                entityDetailName
                value
                additionalInfo {
                  id
                  name
                }
              }
            }
          }
          dam {
            animalName
            entityDetailEnhancers {
              name
              value
            }
            ownerName
            ownerId
            tags {
              entityId
              entityDetailName
              value
              additionalInfo {
                id
                name
              }
            }
            sire {
              animalName
              entityDetailEnhancers {
                name
                value
              }
              ownerName
              ownerId
              tags {
                entityId
                entityDetailName
                value
                additionalInfo {
                  id
                  name
                }
              }
            }
            dam {
              animalName
              entityDetailEnhancers {
                name
                value
              }
              ownerName
              ownerId
              tags {
                entityId
                entityDetailName
                value
                additionalInfo {
                  id
                  name
                }
              }
            }
          }
        }
        dam {
          animalName
          entityDetailEnhancers {
            name
            value
          }
          ownerName
          ownerId
          tags {
            entityId
            entityDetailName
            value
            additionalInfo {
              id
              name
            }
          }
          sire {
            animalName
            entityDetailEnhancers {
              name
              value
            }
            ownerName
            ownerId
            tags {
              entityId
              entityDetailName
              value
              additionalInfo {
                id
                name
              }
            }
            sire {
              animalName
              entityDetailEnhancers {
                name
                value
              }
              ownerName
              ownerId
              tags {
                entityId
                entityDetailName
                value
                additionalInfo {
                  id
                  name
                }
              }
            }
            dam {
              animalName
              entityDetailEnhancers {
                name
                value
              }
              ownerName
              ownerId
              tags {
                entityId
                entityDetailName
                value
                additionalInfo {
                  id
                  name
                }
              }
            }
          }
          dam {
            animalName
            entityDetailEnhancers {
              name
              value
            }
            ownerName
            ownerId
            tags {
              entityId
              entityDetailName
              value
              additionalInfo {
                id
                name
              }
            }
            sire {
              animalName
              entityDetailEnhancers {
                name
                value
              }
              ownerName
              ownerId
              tags {
                entityId
                entityDetailName
                value
                additionalInfo {
                  id
                  name
                }
              }
            }
            dam {
              animalName
              entityDetailEnhancers {
                name
                value
              }
              ownerName
              ownerId
              tags {
                entityId
                entityDetailName
                value
                additionalInfo {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;

// Get Animal
export const GET_ANIMAL_PROGENY = gql`
  query GetAnimal($entityId: Int!, $currentPage: Int!, $pageSize: Int!) {
    animal(entityId: $entityId) {
      entityGuid
      entityId
      entityDetailValues {
        entityId
        entityDetailName
        value
        additionalInfo {
          id
          name
        }
      }
      progeny(pageNumber: $currentPage, pageSize: $pageSize) {
        currentPage
        pageSize
        rowCount
        results {
          entityGuid
          entityId
          entityDetailValues {
            entityId
            entityDetailName
            value
            additionalInfo {
              id
              name
            }
          }
        }
      }
    }
  }
`;

// Get Member
export const GET_MEMBER_FORM = gql`
  query GetMemberForm($memberId: Int!) {
    memberForm(memberId: $memberId) {
      entity {
        entityDetailEnhancers {
          name
          value
        }
        entityGuid
        entityId
        entityDetailValues {
          entityId
          entityDetailName
          value
          additionalInfo {
            id
            name
          }
        }
      }
      form
    }
  }
`;

// Get Member Details
export const GET_MEMBER_DETAILS = gql`
  query GetMemberDetails($orgId: Int!) {
    memberDetails(orgId: $orgId) {
      entityDetailId
      entityDetailName
      isDatabaseSearchEnable
      entityDetailConfigs {
        labelText
        detailName
        detailTypeValue
        options {
          label
          value
        }
      }
    }
  }
`;
